import { Maybe } from '@/types/schema';

export function getUpdatedSubWorkspaceIds(
  contentSubworkspaces?: Maybe<string[]>,
  currentSubWorkspace?: string | null,
) {
  const oldSubWorkspaceIds = contentSubworkspaces?.length ? contentSubworkspaces : undefined;
  const updatedSubWorkspaceIds =
    oldSubWorkspaceIds ?? (currentSubWorkspace ? [currentSubWorkspace] : undefined);
  return updatedSubWorkspaceIds;
}
